<template>
  <div>
    <b-button
      variant="light"
      @click="openModal"
    >
      Spalten-Layout
    </b-button>
    <modal
      name="rowColBtnModal"
      :scrollable="true"
      height="auto"
      width="600px"
      @close="closeModal"
    >
      <b-button
        class="modal-close"
        variant="light"
        @click="closeModal"
      >
        <i class="icon"><icon-times /></i>
      </b-button>
      <div class="modal-header">
        <h4 class="text-center mb-4">
          Anzahl Spalten pro Breakpoint
        </h4>
      </div>
      <div class="modal-body m-4">
        <div class="container">
          <div class="form-group">
            <b-input-group
              prepend="Anzahl Spalten xs"
              class="mb-2"
            >
              <b-form-input
                v-model="colCountXS"
                type="number"
                min="1"
                max="12"
              />
            </b-input-group>
            <b-input-group
              prepend="Anzahl Spalten md"
              class="mb-2"
            >
              <b-form-input
                v-model="colCountMD"
                type="number"
                min="1"
                max="12"
              />
            </b-input-group>
            <b-input-group
              prepend="Anzahl Spalten lg"
              class="mb-2"
            >
              <b-form-input
                v-model="colCountLG"
                type="number"
                min="1"
                max="12"
              />
            </b-input-group>
          </div>
          <b-button
            class="btn-secondary"
            @click.prevent="emitInsert"
          >
            {{ $t('tiptap:btn.ok') }}
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { BInputGroup, BFormInput, BButton } from 'bootstrap-vue';
import IconTimes from 'ICON:IconTimes';

export default ({
  name: 'RowColBtn',
  components: {
    BInputGroup,
    BFormInput,
    BButton,
    IconTimes,
  },
  data() {
    return {
      colCountXS: 1,
      colCountMD: 2,
      colCountLG: 2,
    };
  },
  methods: {
    closeModal() {
      this.colCountXS = 1;
      this.colCountMD = 2;
      this.colCountLG = 2;
      this.$modal.hide('rowColBtnModal');
    },
    emitInsert() {
      const contentArr = [];
      contentArr.length = this.colCountLG;
      contentArr.fill({
        type: 'ColShorttag',
        content: [{ type: 'paragraph', content: [{ type: 'text', text: 'edit col' }] }],
        attrs: {
          colCountXS: this.colCountXS,
          colCountMD: this.colCountMD,
          colCountLG: this.colCountLG,
        },
      });
      this.$emit('insert-content', {
        type: 'RowShorttag',
        content: contentArr,
      });
      this.closeModal();
    },
    openModal() {
      this.$modal.show('rowColBtnModal');
    },
  },
});
</script>
